import { track } from './events';

/**
 * The About Raise Sonar block's event (views/partials/about-promo.hbs):
 * promo_viewed once, when half of it has been on screen. It does nothing
 * else; the block is complete without it, and its sonar turns in CSS.
 */
export function aboutPromo(root: HTMLElement): void {
  const source = root.dataset.promoSource ?? 'site';

  if (!('IntersectionObserver' in window)) return;
  // Half of the promo, or half the screen where the promo is taller than
  // that (stacked on a short phone), since half of it may never fit.
  const io = new IntersectionObserver(
    (entries) => {
      const seen = entries.some((entry) => {
        if (!entry.isIntersecting) return false;
        const screen = entry.rootBounds?.height ?? window.innerHeight;
        const half = Math.min(entry.boundingClientRect.height, screen) / 2;
        return entry.intersectionRect.height >= half;
      });
      if (!seen) return;
      io.disconnect();
      track('promo_viewed', { source });
    },
    { threshold: Array.from({ length: 21 }, (_, i) => i / 20) },
  );
  io.observe(root);
}
